const EXPORT_ONLY_HEADERS = new Set(
  [
    'Sévérité',
    'Severity',
    "Inclus dans l'offre",
    'Included in the offer',
    'Position',
    'Type',
    'TVASM',
    'Type de produit',
    'Product type',
  ].map((header) => header.toLowerCase())
);

const EXPORT_ONLY_PREFIXES = ['erreur - ', 'error - '];

export const isExportOnlyHeader = (header: string): boolean => {
  const normalized = header.trim().toLowerCase();
  return (
    EXPORT_ONLY_HEADERS.has(normalized) ||
    EXPORT_ONLY_PREFIXES.some((prefix) => normalized.startsWith(prefix))
  );
};

export const withoutExportOnlyHeaders = (headers: string[]): string[] =>
  headers.filter((header) => !isExportOnlyHeader(header));
